import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class ModalResultadosConversionService {
    constructor() {
        this.mostrarModalSubject = new BehaviorSubject(false);
        this.datosSubject = new BehaviorSubject([]);
        this.mostrarModal$ = this.mostrarModalSubject.asObservable();
        this.datos$ = this.datosSubject.asObservable();
    }
    /**
     * Muestra el modal con los datos de conversión
     */
    mostrarModal(datos) {
        this.datosSubject.next(datos);
        this.mostrarModalSubject.next(true);
    }
    /**
     * Oculta el modal
     */
    ocultarModal() {
        this.mostrarModalSubject.next(false);
        this.datosSubject.next([]);
    }
}
ModalResultadosConversionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalResultadosConversionService_Factory() { return new ModalResultadosConversionService(); }, token: ModalResultadosConversionService, providedIn: "root" });
